class ScrollDirection {
    set_position = 0;
    direction = null;
    upcollback = [];
    downcollback = [];

    constructor() {
        this.start();
    }

    start() {
        window.addEventListener('scroll', () => {
            if (this.set_position < document.documentElement.scrollTop && (this.direction == "up" || this.direction == null)) {
                // console.log("down");
              this.direction = "down";
              this.downcollback.map(func => {
                func();
              });
            } else if(this.set_position > document.documentElement.scrollTop && (this.direction == "down"  || this.direction == null)) {
                // console.log("up");
              this.direction = "up";
              this.upcollback.map(func => {
                func();
              });
            };
            this.set_position = document.documentElement.scrollTop;
          });
    }

    getDirection() {
        return this.direction;
    }

    setUpCollBack(func) {
        console.log("setUpCollBack");
        this.upcollback.push(func);
    }

    setDownCollBack(func) {
        this.downcollback.push(func);
    }
};

export default new ScrollDirection;